import React, { Component } from "react";
import { connect } from "@common/components/base.component";
import Address from "@common/components/addressGlobal/components/address.global.component";
import enderecoCobrancaSelector from "../store/enderecoCobranca.selectors";
import enderecoCobrancaActions from "../store/enderecoCobranca.actions";
import { Row, Col } from "react-bootstrap";
import autoBind from "react-autobind";
import Panel from "@common/externos/components/panel/panel.component";

class Container extends Component {
  constructor(props) {
    super(props);
    autoBind(this);
  }

  onFocusCEP() {
    this.props.enderecoCobrancaActions.getDadosEnderecoPrincipal();
  }

  render() {
    let { enderecoCobrancaSelector, prefix } = this.props;
    const { enderecoCobranca } = enderecoCobrancaSelector;

    return (
      <Panel title={"Endereço de Cobrança"} defaultExpanded={false}>
        <Row>
          <Col>
            <Address
              name="EnderecoCobranca"
              state={enderecoCobranca}
              prefix={prefix}
              allowExterior={false}
              onFocusCep={this.onFocusCEP}
              onBlur={(values) =>
                this.props.enderecoCobrancaActions.setEnderecoCobranca(values)
              }
            />
          </Col>
        </Row>
      </Panel>
    );
  }
}

export default connect({
  selectors: {
    enderecoCobrancaSelector,
  },
  actions: {
    enderecoCobrancaActions,
  },
})(Container);
